import React from "react";
import {
  Grid,
  Avatar,

} from "@material-ui/core";

import { useUserContext } from "../../context/UserContext";

// styles
import useStyles from "./styles";

// components
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { Typography } from "../../components/Wrappers/Wrappers";

export default function UserProfile(props) {
  var classes = useStyles();
  var Profile = useUserContext().userInformation;
  var accountCreated = Profile?.accountCreated?.toDate();

  return (
    <>
      <PageTitle title={'Personal Profile'} />
      <Grid container spacing={4}>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Widget
            title='Basic Information'
            upperTitle
            className={classes.card}
            bodyClass={classes.fullHeightBody}
          >
            <div className={classes.performanceLegendWrapper}>
              <div className={classes.legendElement}>
                <Typography
                  color="text"
                  colorBrightness="secondary"
                >
                  Name: {Profile?.name} <br/>
                  Email: {Profile?.email} <br />
                  {accountCreated ? `Account Active Since: ${accountCreated.getMonth()}/${accountCreated.getDate()}/${accountCreated.getFullYear()}`
                  : null }
                </Typography>
              </div>
            </div>
            <div className={classes.progressSection}>
              {Profile?.avatar ? 
              <Avatar src={'data:image/png;base64,' + Profile.avatar} className={classes.large} />
              : <Avatar className={classes.large} />}
            </div>
          </Widget>
        </Grid>
        {/* <Grid item lg={6} md={6} sm={6} xs={12}>
          <Widget
            title='Scorecard'
            upperTitle
            className={classes.card}
            bodyClass={classes.fullHeightBody}
          >
            <div className={classes.performanceLegendWrapper}>
              <div className={classes.legendElement}>
                <Typography
                  color="text"
                  colorBrightness="secondary"
                >
                  Real Estate Portfolio Grade: {Profile?.dashboard?.portfolioGrade} <br/>
                  Real Estate Portfolio Analysis for Earnings Generation: {Profile?.dashboard?.generationGrade} <br />
                  Operating Expense & Occupancy Cost Savings: {Profile?.dashboard?.savingsGrade} <br/>
                  Monetization of Excess Real Estate Assets: {Profile?.dashboard?.assetsGrade} <br/>
                  IT Tools for Earnings Measurment: {Profile?.dashboard?.measurementGrade} <br/>
                </Typography>
              </div>
            </div>
            <div className={classes.progressSection}>
            </div>
          </Widget>
        </Grid> */}
      </Grid>
    </>
  );
}
